var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiveGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    fill: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#ffffff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:3;} .st2{fill:none;stroke:#ffffff;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;} .st3{fill:none;} "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3,24l2.6-4.2c1.5-2.3,4-3.8,6.8-3.8H19v0c0,2.2-1.8,4-4,4h-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,20h8l1.2-1.6c1.1-1.5,2.9-2.4,4.8-2.4h0l-2.7,4.8c-1.4,2.6-4.2,4.2-7.1,4.2h0c-4.7,0-9.3,1.4-13.2,4l0,0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 7,
    className: "st0",
    width: 16,
    height: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,7h-1.7C14,7,13,6,13,4.7v0C13,3.8,13.8,3,14.7,3h0C16,3,17,4,17,5.3V7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17,7h1.7C20,7,21,6,21,4.7v0C21,3.8,20.2,3,19.3,3h0C18,3,17,4,17,5.3V7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "10.8,16 10.8,11 23.2,11 23.2,20 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: -504,
    y: -432,
    className: "st3",
    width: 536,
    height: 680
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveGift);
export default __webpack_public_path__ + "static/media/give-gift.601f12ab38c8fe24e18911f4de9e311c.svg";
export { ForwardRef as ReactComponent };